module.exports = __webpack_public_path__ + "img/img2b.71a8f30d.png";